import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'
//

import styles from './style.module.scss'
import { payload } from '@shared/libs/category'
import { isBottomReached } from '@shared-submodule/utils'
import { GET_TAG_ARTICLE } from '@graphql/tag/tag.query'
import { articleLoader } from '@shared/libs/allLoader'
import { GET_CATEGORY_NEWS_VIDEOS, GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { HOME_FANTASY_ARTICLE } from '@graphql/home/home.query'
import { GET_RANDOM_ARTICLE } from '@graphql/article/article.query'
import LazyLoad from '@shared/components/lazyLoad'
// import ArticleBig from '@shared/components/article/articleBig'
import ArticleSmall from '@shared/components/article/articleSmall'
import ArticleGrid from '@shared/components/article/articleGrid'
import NoData from '@shared/components/noData'
import useWindowSize from '@shared/hooks/windowSize'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
import dynamic from 'next/dynamic'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const SeriesNews = ({ data, category, hideBadge, isClientOnly }) => {
  const [newsData, setNewsData] = useState(data?.aResults || [])
  const loading = useRef(false)
  const payloadNews = useRef({ ...payload(7) })
  const [isLoading, setIsLoading] = useState(false)
  const [width] = useWindowSize()

  const [getSeriesNews, { data: seriesNews, sLoading }] = useLazyQuery(GET_SERIES_NEWS_VIDEOS)
  const [getCategoryNews, { data: simpleNews, cLoading }] = useLazyQuery(GET_CATEGORY_NEWS_VIDEOS)
  const [tagArticle, { data: tagArticles, tLoading }] = useLazyQuery(GET_TAG_ARTICLE)
  const [getfantasyArticles, { data: fantasyArticleData, fLoading }] = useLazyQuery(HOME_FANTASY_ARTICLE)
  const [getRandomArticles, { data: randomArticle, rLoading }] = useLazyQuery(GET_RANDOM_ARTICLE, {
    variables: { input: { nSample: 10 } },
    onCompleted: article => {
      article?.randomArticles && setNewsData(article?.randomArticles)
    }
  })

  const latestNews = useRef(getLengthForPagination())

  useEffect(() => {
    loading.current = false
    setIsLoading(false)
    latestNews.current = getLengthForPagination()
    if (newsData?.length && !randomArticle) isBottomReached(newsData[newsData.length - 1]?._id, isReached)
  }, [newsData])

  useEffect(() => {
    const value = tagArticles?.getTagArticlesFront || fantasyArticleData?.listFrontFantasyArticle
    if (value && value?.aResults?.length !== 0) {
      setNewsData([...newsData, ...value?.aResults])
    } else if (value && !newsData?.length) {
      getRandomArticles()
    }
  }, [tagArticles, fantasyArticleData])

  useEffect(() => {
    const value = seriesNews?.listSeriesArticlesVideosFront || simpleNews?.listSimpleCategoryArticlesVideosFront
    if (value && value?.oArticles?.aResults?.length !== 0) {
      setNewsData([...newsData, ...value?.oArticles?.aResults])
    } else if (value && !newsData?.length) {
      getRandomArticles()
    }
  }, [seriesNews, simpleNews])

  useEffect(() => {
    if (isClientOnly) {
      if (category?.eType === 'gt' || category?.eType === 'p' || category?.eType === 't') {
        // General tag, Player, and Team
        payloadNews.current.eType = category?.eType
        tagArticle({ variables: { input: { _id: category?.iId, ...payloadNews.current } } })
      } else if (category?.eType === 's' || category?.eType === 'fac' || category?.eType === 'pct') {
        // simple category
        getCategoryNews({ variables: { input: { iCategoryId: category?._id, eType: 'n', ...payloadNews.current } } })
      }
    } else if (!isClientOnly && data?.aResults?.length === 0) {
      // Only for series category page
      getRandomArticles()
    }
  }, [isClientOnly])

  async function isReached(reach) {
    if (reach && !loading.current && (latestNews.current === 7 || latestNews.current === 16)) {
      setIsLoading(true)
      loading.current = true
      setPayload(category?.eType === 'gt' || category?.eType === 'p' || category?.eType === 't')
      getMoreData()
    }
  }

  async function getMoreData() {
    if (category?.eType === 'as') {
      // Series category
      const { data } = await getSeriesNews({ variables: { input: { iSeriesId: category?.iSeriesId, eType: 'n', ...payloadNews.current } } })
      setIsLoading(false)
      return data?.listSeriesArticlesVideosFront
    } else if (category?.eType === 'gt' || category?.eType === 'p' || category?.eType === 't') {
      // tag
      const { data } = await tagArticle({ variables: { input: { _id: category?.iId, ...payloadNews.current } } })
      setIsLoading(false)
      return data?.getTagArticlesFront?.aResults
    } else if (category.eType === 'ct') {
      // for fantasy articles category
      const { data } = await getfantasyArticles({
        variables: { input: { iId: category?.iId, ...payloadNews.current } }
      })
      setIsLoading(false)
      return data?.listFrontFantasyArticle
    } else {
      // simple category
      const { data } = await getCategoryNews({ variables: { input: { iCategoryId: category?._id, eType: 'n', ...payloadNews.current } } })
      setIsLoading(false)
      return data?.listSimpleCategoryArticlesVideosFront
    }
  }

  function setPayload(isTag) {
    payloadNews.current = { ...payloadNews.current, nSkip: payloadNews.current.nSkip + 1 }
    if (isTag) payloadNews.current.eType = category?.eType
  }

  function getLengthForPagination() {
    return (
      seriesNews?.listSeriesArticlesVideosFront?.oArticles?.aResults?.length ||
      simpleNews?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults?.length ||
      tagArticles?.getTagArticlesFront?.aResults?.length ||
      fantasyArticleData?.listFrontFantasyArticle?.aResults?.length ||
      data?.aResults?.length
    )
  }

  const { addTop, mobSm } = reviveAdData

  return (
    <>
      {newsData?.length !== 0 && (
        <div className={styles.seriesHome}>
          {/* <h3 className='small-head'>
            Latest News
          </h3> */}
          <Row>
            {newsData?.map((news, i) => {
              // if (i === 0) {
              //   return (
              //     <React.Fragment key={news._id}>
              //       <Col xs={12} id={news?._id}>
              //         sss<ArticleBig isFullCard={true} isLarge={true} data={news} hideBadge={hideBadge} />
              //       </Col>
              //     </React.Fragment>
              //   )
              // }
              if (i >= 0 && i < 6) {
                if (width > 767) {
                  return (
                    <React.Fragment key={news._id}>
                      <Col lg={4} sm={6} id={news?._id}>
                        <ArticleGrid data={news} />
                      </Col>
                      {/* testing for now  */}
                      {
                        (i + 1) % 3 === 0 && (i + 1) !== 6 && (
                          <Col md={12}>
                            <p></p>
                            <p></p>
                            <p></p>
                            <div>
                            {
                              width > 767 ? <script src="https://cdn.fcp.codes/embed-code-template/embed-code-template.js#SEMANTIC_b6628fa2-fd42-4851-a23f-e34fe87937c3"></script> : <script src="https://cdn.fcp.codes/embed-code-template/embed-code-template.js#SEMANTIC_a59a6318-f348-41d6-a642-37428ce107a4"></script>
                            }
                            </div>
                          </Col>
                        )
                      }
                    </React.Fragment>
                  )
                } else {
                  if (i < 2) {
                    return (
                      <React.Fragment key={news._id}>
                        <Col lg={4} sm={6} id={news?._id}>
                          <ArticleGrid data={news} />
                        </Col>
                      </React.Fragment>
                    )
                  } else {
                    return (
                      <LazyLoad key={news._id}>
                        <React.Fragment key={news._id}>
                          <Col lg={4} sm={6} id={news?._id}>
                            <ArticleGrid data={news} />
                          </Col>
                        </React.Fragment>
                      </LazyLoad>
                    )
                  }
                }
              } else {
                return (
                  <LazyLoad key={news?._id}>
                    {i % 8 === 0 && i !== 8 && width > 767 && (
                      <Col md={12}>
                        {/* <GoogleAds
                          addId={googleAddData?.addTop?.addId}
                          divId={googleAddData?.addTop?.divId}
                          dimension={googleAddData?.addTop?.dimension}
                          slotId={googleAddData?.addTop?.slotId}
                          className={'mt-0 mb-4'}
                        /> */}
                        <ReviveAds {...addTop} className={'w-full d-flex justify-content-center mt-0 mb-4'}/>
                      </Col>
                    )}
                    {i % 4 === 0 && i !== 8 && width < 767 && (
                      <Col md={12}>
                        {/* <GoogleAds
                          addId={googleAddData?.mobSm?.addId}
                          divId={googleAddData?.mobSm?.divId}
                          dimension={googleAddData?.mobSm?.dimension}
                          slotId={googleAddData?.mobSm?.slotId}
                          className={'mt-0 mb-4'}
                        /> */}
                        <ReviveAds {...mobSm} className={'w-full d-flex justify-content-center mt-0 mb-4'}/>
                      </Col>
                    )}
                    <Col key={news?._id} md={6} id={news?._id}>
                      <ArticleSmall isLarge={false} data={news} hideBadge={hideBadge} />
                    </Col>
                  </LazyLoad>
                )
              }
            })}
          </Row>
          {isLoading && articleLoader(['s', 's'])}
        </div>
      )}
      {!(sLoading || rLoading || fLoading || tLoading || cLoading || !isLoading) && newsData?.length === 0 && <NoData />}
    </>
  )
}

SeriesNews.propTypes = {
  data: PropTypes.object,
  category: PropTypes.object,
  hideBadge: PropTypes.bool,
  isClientOnly: PropTypes.bool
}

export default SeriesNews
